export const styles = {
  global: {
    body: {
      textTransform: 'uppercase',
      letterSpacing: '.04375rem',
      color: 'grey.1',
      bg: 'black',
      width: '100%'
    }
  }
}
